import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
} from "@ionic/react";
import { FC } from "react";
import "./ScorzaCard.css";

export interface ScorzaCardProps {
    title?: string;
    className?: string;
}

export const ScorzaCard: FC<ScorzaCardProps> = ({
    children,
    title,
    className,
}) => {
    return (
        <IonCard className={`scorza-card${className ? ` ${className}` : ""}`}>
            <IonCardHeader>
                <IonCardTitle>
                    <h2>{title}</h2>
                </IonCardTitle>
            </IonCardHeader>
            {children}
        </IonCard>
    );
};
